import { z } from 'zod';
import { vatIdSchema } from '@/shared/lib/validation/vat-id/vat-id.schema';


export const companySchema = z.object({
    address     : z.string().min(1, 'Street address is required'),
    city        : z.string().min(1, 'City is required'),
    company_name: z.string().min(2, 'Company name is required'),
    company_vat : vatIdSchema,
    country     : z.string().min(1, 'Country is required'),
    postal_code : z.string().min(4, 'Postal code is required'),
});

export type CompanyFormData = z.infer<typeof companySchema>;
